module.exports = __webpack_public_path__ + "static/img/2.b173046.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/2.png
// module id = yziu
// module chunks = 0